// @ts-nocheck
function fireCartAddEvent(sourceId) {
  const e = new Event('cart:update', { bubbles: true });
  e.detail = { resource: {}, sourceId: sourceId || 'custom', data: {} };
  document.dispatchEvent(e);
}

class QuickviewProduct extends HTMLElement {
  constructor() {
    super();
    this.handleAddToCart = this.handleAddToCart.bind(this);
  }

  connectedCallback() {
    this.updateSelectedValue();
    this.addButton = this.querySelector('[data-add-to-cart]');
    this.closeButtons = this.querySelectorAll('[data-quickview-close], .quickview_overlay');

    // Hide + sync variants of bundle product
    this.applyVariantFilteringAndSync();

    if (!this.addButton) {
      return;
    }

    this.addButton.addEventListener('click', this.handleAddToCart);
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.closeDrawer.bind(this));
    });
  }

  disconnectedCallback() {
    if (this.addButton) {
      this.addButton.removeEventListener('click', this.handleAddToCart);
    }
    this.closeButtons.forEach(button => {
      button.removeEventListener('click', this.closeDrawer.bind(this));
    })
  }
  
  updateSelectedValue() {
    const inputs = this.querySelectorAll('.variant-option__button-label input');
    inputs.forEach(input => {
      input.addEventListener('change', ()=> {
        const fieldset = input.closest('.custom-variant-picker .variant-option');
        const selectedValue = fieldset.querySelector('.variant-option__selected-value');
        if (selectedValue) {
          selectedValue.textContent = input.value;
        }
      })
    })
  }

  applyVariantFilteringAndSync() {
    const mainOptions = [];
    const addonFieldsets = [];

    /* ----------------------------------------------------------
    * 1. Collect MAIN product options + allowed values
    * ---------------------------------------------------------- */
    this.querySelectorAll(".quickview-product__variants [quickview-variant-picker] fieldset").forEach(fieldset => {
      const legend = fieldset.querySelector("legend");
      if (!legend) return;

      const optionName = legend.dataset.productOption.toLowerCase();
      const values = [...fieldset.querySelectorAll("input[type='radio']")].map(i => i.value.trim());

      mainOptions.push({
        name: optionName,
        values: values
      });
    });

    /* ----------------------------------------------------------
    * 2. Collect ADDON variant fieldsets
    * ---------------------------------------------------------- */
    this.querySelectorAll("[component-variant-picker] fieldset").forEach(fieldset => {
      const legend = fieldset.querySelector("legend");
      if (!legend) return;

      addonFieldsets.push({
        name: legend.dataset.productOption.toLowerCase(),
        fieldset: fieldset
      });
    });

    /* ----------------------------------------------------------
    * 3. Hide mismatched addon options (substring match)
    * ---------------------------------------------------------- */
    addonFieldsets.forEach(addon => {
      const addonName = addon.name;

      const matchedMain = mainOptions.find(main =>
        main.name.includes(addonName)
      );

      if (!matchedMain) return; // No match → skip hiding

      const allowedValues = matchedMain.values;

      addon.fieldset.querySelectorAll(".variant-option__button-label").forEach(label => {
        const input = label.querySelector("input[type='radio']");
        const value = input?.value.trim();

        if (!allowedValues.includes(value)) {
          label.style.display = "none";
        } else {
          label.style.display = "";
        }
      });
    });

    /* ----------------------------------------------------------
    * 4. Sync ADDON click → MAIN click
    * addon input[data-id="x"] → main input#x
    * ---------------------------------------------------------- */
    this.querySelectorAll("[component-variant-picker] input[type='radio']").forEach(addonInput => {

      addonInput.addEventListener("click", () => {
        const id = addonInput.dataset.id;
        if (!id) return;

        const mainInput = this.querySelector(`[quickview-variant-picker] input#${CSS.escape(id)}`);

        if (mainInput) {
          mainInput.click(); // triggers Shopify logic + updates UI
        }
      });

    });
  }

  openCartDrawer() {
    setTimeout(() => {
      document.querySelector('cart-drawer-component')?.open();
    }, 400);
  }

  closeDrawer() {
    document.querySelector('.quickview-sidebar').classList.remove('active');
    document.querySelector('.quickview_overlay').classList.remove('active');
    document.body.classList.remove('scroll_hidden');
    this.openCartDrawer();
  }

  async handleAddToCart(event) {
    event.preventDefault();
    if (this.addButton.disabled) return;
    const label = this.addButton.querySelector('.klyr-sponge-offer__button-label') || this.addButton;
    const originalLabel = label.textContent;
    const checked = this.querySelector('.new-variant-picker__form input[type="radio"]:checked');
    const variantId = checked?.dataset.variantId || this.addButton.dataset.variantId;
    const quantity = this.addButton.dataset.quantity || 1;
    const sellingPlan = this.dataset.sellingPlan ? parseInt(this.dataset.sellingPlan, 10) : null;
    const cartItem = { id: variantId, quantity };
    if (sellingPlan) cartItem.selling_plan = sellingPlan;
    this.addButton.disabled = true;
    label.textContent = this.addButton.dataset.loadingLabel || Theme.translations.adding_to_cart;
    this.querySelector('[data-upsell-error]')?.remove();
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(cartItem)
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
      }
      label.textContent = this.addButton.dataset.addedLabel || Theme.translations.added_to_cart;
      fireCartAddEvent('quickview-upsell');
      this.emitCartUpdated();
      document.querySelector('.cart-drawer__dialog')?.classList.remove('cart-drawer--empty');
      this.closeDrawer();
    } catch (error) {
      label.textContent = originalLabel;
      const message = document.createElement('p');
      message.dataset.upsellError = '';
      message.setAttribute('role', 'alert');
      message.textContent = error.message || 'Unable to add this item. Please try again.';
      this.addButton.after(message);
    } finally {
      this.addButton.disabled = false;
    }
  }

  async emitCartUpdated() {
    // dispatch signal again
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    const newCart = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: newCart }));
  }

  // rerenderCart() {
  //   const sectionId = document.querySelector('#header-component').dataset.sectionId;
  //   fetch(`/?sections=${sectionId}`)
  //     .then(res => {
  //       if (!res.ok) throw new Error(`Cart fetch failed with ${res.status}`);
  //       return res.json();
  //     })
  //     .then(data => {
  //       const cartDrawer = document.querySelector('.cart-drawer__inner');
  //       if (!cartDrawer) {
  //         return;
  //       }

  //       const tempDiv = document.createElement('div');
  //       tempDiv.innerHTML = data[sectionId];

  //       const newContent = tempDiv.querySelector('.cart-drawer__inner');
  //       if (!newContent) {
  //         return;
  //       }

  //       // Update the cart drawer content
  //       cartDrawer.innerHTML = newContent.innerHTML;
  //     })
  //     .catch(() => {
  //       console.error("Failed to update cart drawer.");
  //     })
  //     .finally(() => {
  //       this.closeDrawer();
  //     });
  // }
}

if(!customElements.get('custom-quickview-product')) {
  customElements.define('custom-quickview-product', QuickviewProduct);
}


